import React, {Component} from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { geoJsonDataForSpot, priceInDollars } from './../../utils';
import {CHECKOUT_EVENTS} from './../../constants';

class SpotToReserve extends Component {

  spotStatusString() {
    const {event, isInValidTimer} = this.props;
    let spotStatus = 'Pending';
    if (isInValidTimer) {
      spotStatus = 'Available';
    } else if (event === CHECKOUT_EVENTS.trade) {
      spotStatus = <span className="color-success-alt"><i className="fa fa-check-circle"/>&nbsp;Will be added</span>;
    }

    return spotStatus;
  }

  render() {
    const {spotName, event} = this.props;
    const spotDetails = geoJsonDataForSpot(spotName);
    const {location, size, price, surface} = spotDetails.properties;

    return (
      <div className="panel panel-spot">
      <div className="panel-body">
        <h5>
          <div className="icon-marker-pin pull-left" />
          &nbsp;
          {`${location} ${spotName}`}
        </h5>
        <p>
          <span className="text-capitalize">{surface}</span> { size.trim() ? `- ${size}` : ''}
          <br/>
          { this.spotStatusString() }
          <span className="pull-right">
            <strong>
              { priceInDollars(price) }
            </strong>
          </span>
        </p>
        </div>
      </div>
    );
  }

}


export default SpotToReserve;



// WEBPACK FOOTER //
// ./src/containers/checkout/SpotToReserve.js